module.exports = __webpack_public_path__ + "img/nz.55c65e06.svg";